export function Body({ children }: { children: React.ReactNode }) {
  return (
    <main className="site-body" id="main">
      {children}
    </main>
  );
}
